export { AiDetailPanel } from './AiDetailPanel';
